import { FC } from 'react';
import { EndUserTypography } from '../../../../components/EndUserTypography';
import styles from './index.module.scss';
import { FoundElementT } from '../../../../lib/hooks/endUserHooks/useGetCampaignObjectPositions';
import { CampaignObjectImage } from '../../../../components/CampaignObjectImage';

type Props = {
  name: string;
  text: string;
  title: string;
  picture: any;
  campaignObject?: FoundElementT | null;
};

export const BonusCard: FC<Props> = ({ text, title, picture, campaignObject }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.imgWrapper}>
        <img className={styles.img} src={picture?.s3Url} alt="bonus-bg" />

        {campaignObject && (
          <div className={styles.campaignObjectWrapper}>
            <CampaignObjectImage campaignObject={campaignObject} />{' '}
          </div>
        )}
      </div>
      <div className={styles.textWrapper}>
        <div style={{ marginBottom: 8 }}>
          <EndUserTypography
            type="headlineFourth"
            component="Text"
            className={styles.title}
          >
            {title}
          </EndUserTypography>
        </div>
        <EndUserTypography
          ellipsis={{ rows: 6 }}
          className={styles.paragraph}
          type="subText"
          component="Paragraph"
        >
          {text}
        </EndUserTypography>
      </div>
    </div>
  );
};
